import React from 'react';
import DataTable from "../../components/data-table";
import axios from 'axios';
import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { dateFormat } from '../../utils/date';
import { Authorize } from '../../components/authorize';
let disable;
export default class Reports extends Authorize {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.createPdf = this.createPdf.bind(this);
    }
    getYears() {
        let startYear = 2017;
        let d = new Date();
        let currentYear = d.getFullYear();
        let years = [];
        for (var i = startYear; i <= currentYear; i++) {
            years.push(i);
        }
        return years;
    }
    getToday() {
        let dt = new Date();
        let d = dt.getDate();
        let m = dt.getMonth() + 1;
        let y = dt.getFullYear();
        if (m < 10) {
            m = "0" + m;
        }
        if (d < 10) {
            d = "0" + d;
        }
        return y + "-" + m + "-" + d;
    }
    state = {
        years: this.getYears(),
        months: [
            { id: "01", label: "January" }, { id: "02", label: "February" },
            { id: "03", label: "March" }, { id: "04", label: "April" },
            { id: "05", label: "May" }, { id: "06", label: "June" },
            { id: "07", label: "July" }, { id: "08", label: "August" },
            { id: "09", label: "September" }, { id: "10", label: "October" },
            { id: "11", label: "November" }, { id: "1", label: "December" }
        ],
        today: this.getToday(),
        dateErr: {},
        yearMonth: {},
        fromTo: {},
        selectType: "",
        headers: [
            { title: "First Name", accessor: "firstName", index: 0, dataType: "string" },
            { title: "Last Name", accessor: "lastName", index: 1, dataType: "string" },
            { title: "Aadhaar Number", accessor: "AdharNo", index: 2, dataType: "string" },
            { title: "PAN", accessor: "PanNo", index: 3, dataType: "string" },
            { title: "GST Number", accessor: "GSTNO", index: 4, dataType: "string" },
            { title: "Status", accessor: "Status", index: 5, dataType: "string" },
            { title: "Updated At", accessor: "updatedAt", index: 6, dataType: "string" },
        ],
        data: [],
        submited: false
    }
    onClick(e) {
        this.setState({
            selectType: e.target.value,
            yearMonth: {},
            fromTo: {},
            dateErr: {},
            data: [],
            submited: false
        })
    }
    onChange(e) {
        let dateErr = Object.assign({}, this.state.dateErr);
        let name = e.target.name;
        let value = e.target.value;
        if (this.state.selectType === "year-month") {
            this.setState({
                yearMonth: {
                    ...this.state.yearMonth,
                    [name]: value
                }
            })
        }
        else if (this.state.selectType === "from-to") {
            this.setState({
                fromTo: {
                    ...this.state.fromTo,
                    [name]: value
                }
            }, () => {
                if (this.state.fromTo.from > this.state.today) {
                    dateErr.fromErr = "From Date should not be greater than Today's Date";
                }
                else {
                    dateErr.fromErr = "";
                }
                if (this.state.fromTo.to > this.state.today) {
                    dateErr.toErr = "To Date should not be greater than Today's Date";
                }
                else {
                    dateErr.toErr = "";
                }
                this.setState({
                    dateErr: dateErr
                }, () => {
                    if (!this.state.dateErr.fromErr && !this.state.dateErr.toErr && (this.state.fromTo.from > this.state.fromTo.to)) {
                        dateErr.diffErr = "To Date should be greater than From Date";
                    }
                    else {
                        dateErr.diffErr = "";
                    }
                    this.setState({
                        dateErr: dateErr
                    })
                })
            })
        }
    }
    disableButton() {
        if (this.state.selectType === "year-month") {
            if (this.state.yearMonth.year && this.state.yearMonth.month) {
                disable = false
            }
            else {
                disable = true
            }
        }
        else if (this.state.selectType === "from-to") {
            if (this.state.fromTo.from && this.state.fromTo.to && !this.state.dateErr.fromErr && !this.state.dateErr.toErr && !this.state.dateErr.diffErr) {
                disable = false
            }
            else {
                disable = true
            }
        }
    }
    onSubmit() {
        let data;
        if (this.state.selectType === "year-month") {
            data = this.state.yearMonth;
        }
        else if (this.state.selectType === "from-to") {
            data = this.state.fromTo;
        }
        axios({
            method: 'post',
            responseType: 'json',
            url: '/admin/getReports',
            data: data
        })
            .then((response) => {
                let data = response.data
                data.map(m => {
                    let df = dateFormat(m.updatedAt);
                    return m.updatedAt = df;
                });
                this.setState({
                    data: data,
                    submited: true
                })
            })
            .catch((err) => {
            });
    }
    getFileName() {
        let date = new Date(),
            dateformat = [date.getDate(),
            date.getMonth() + 1,
            date.getFullYear(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
            ].join('-');
        let fileName;
        if (this.state.selectType === "year-month") {
            fileName = "Report in Year-Month_" + dateformat;
        }
        else if (this.state.selectType === "from-to") {
            fileName = "Report in From Year-To Year_" + dateformat;
        }
        return fileName;
    }
    getCsvHeader() {
        let csvHeaders = this.state.headers.map(h => {
            return Object.assign(
                {},
                {
                    label: h.title,
                    key: h.accessor
                }
            )
        });
        return csvHeaders;
    }
    createPdf() {
        let pdfHeaders = this.state.headers.map(h => {
            return Object.assign(
                {},
                {
                    title: h.title,
                    key: h.accessor
                }
            )
        });
        let title;
        if (this.state.selectType === "year-month") {
            this.state.months.map(f => {
                if (f.id === this.state.yearMonth.month) {
                    title = "Report : " + f.label + " " + this.state.yearMonth.year;;
                }
                return title
            })
        }
        else if (this.state.selectType === "from-to") {
            title = "Report : " + this.state.fromTo.from + " to " + this.state.fromTo.to;
        }
        var doc = new jsPDF('p', 'pt');
        doc.setFontSize(20);
        doc.setTextColor(40);
        doc.setFontStyle('normal');
        doc.text(title, 10, 20);
        doc.autoTable(pdfHeaders, this.state.data, {
            startY: doc.autoTableEndPosY() + 70,
            margin: { horizontal: 10 },
            styles: { overflow: 'linebreak' },
            bodyStyles: { valign: 'top' },
            theme: "striped"
        });
        doc.save(this.getFileName() + ".pdf");
    }
    render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

        this.disableButton();
        return (
            <React.Fragment>
                <div className="container">
                    <div className="row">
                        <div>&nbsp;</div>
                        <div className="col-md-12">
                            <h4>KYC'S</h4>
                            <div>&nbsp;</div>
                            <div className="form-control">
                                <div>
                                    <input type="radio" name="selectType" value="year-month" onClick={this.onClick} />
                                    &nbsp;
                                    <label>Year-Month</label>
                                    &nbsp;&nbsp;
                                    <input type="radio" name="selectType" value="from-to" onClick={this.onClick} />
                                    &nbsp;
                                    <label>From-To</label>
                                </div>
                                {this.state.selectType === "year-month" ?
                                    <div>
                                        <select name="year" onChange={this.onChange}>
                                            <option value="select" selected={true} disabled="disabled">Select Year</option>
                                            {
                                                this.state.years.map(y =>
                                                    <option key={y} value={y}>{y}</option>
                                                )
                                            }
                                        </select>
                                        &nbsp;&nbsp;
                                        <select name="month" onChange={this.onChange}>
                                            <option value="select" selected={true} disabled="disabled">Select Month</option>
                                            {
                                                this.state.months.map(m =>
                                                    <option key={m.id} value={m.id}>{m.label}</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                    : null}
                                {this.state.selectType === "from-to" ?
                                    <div>
                                        <input type="date" name="from" max={this.state.today} onChange={this.onChange} />
                                        &nbsp;&nbsp;
                                    <input type="date" name="to" max={this.state.today} onChange={this.onChange} />
                                        <span></span>
                                    </div>
                                    : null}
                                {this.state.dateErr ?
                                    <React.Fragment>
                                        <div>{this.state.dateErr.fromErr}</div>
                                        <div>{this.state.dateErr.toErr}</div>
                                        <div>{this.state.dateErr.diffErr}</div>
                                    </React.Fragment>
                                    : null}
                                <br />
                                {this.state.selectType ?
                                    <button className="btn btn-primary" onClick={this.onSubmit} disabled={disable}>Submit</button>
                                    : null}
                                <br />
                                {this.state.data && this.state.data.length > 0 && this.state.submited ?
                                    <React.Fragment>
                                        <CSVLink
                                            headers={this.getCsvHeader()}
                                            data={this.state.data}
                                            filename={this.getFileName() + ".csv"}
                                        >
                                            <img src="/images/csv.jpg" title="Download in CSV" alt="Download in CSV" style={{ height: "30px", width: "30px" }} />
                                        </CSVLink>
                                    </React.Fragment>
                                    : null}
                                &nbsp;&nbsp;&nbsp;
                                {this.state.data && this.state.data.length > 0 && this.state.submited ?
                                    <a onClick={this.createPdf}><img src="/images/pdf.jpg" title="Download in PDF" alt="Download in PDF" style={{ height: "30px", width: "30px" }} /></a>
                                    : null}
                                {this.state.data && this.state.data.length > -1 && this.state.submited ?
                                    <DataTable className="data-table"
                                        keyField="id"
                                        pagination={{
                                            enabled: true,
                                            pageLength: 5,
                                            type: "long"
                                        }}
                                        width="100%"
                                        headers={this.state.headers}
                                        data={this.state.data}
                                        noData="No records!" />
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}